import api from "../../";
import { uploadFile } from "../../file/uploadFile";
import type { Banner, PatchBannerBody, PatchBannerParams } from "./types";
import type { ApiResponse } from "../../types";

export const patchBanner = async ({ uuid, originalBanner, title, description, related_content, desktopCoverFile, phoneCoverFile }: PatchBannerParams): Promise<boolean> => {

  const body: PatchBannerBody = {};

  if (title !== originalBanner.title) body.title = title;
  if (description !== originalBanner.description) body.description = description;
  if (related_content !== originalBanner.related_content) body.related_content = related_content;

  if (desktopCoverFile) {
    const key = await uploadFile({
      file: desktopCoverFile,
      signBody: {
        item_type: "course",
        item_id: Date.now(),
        object_name: desktopCoverFile.name,
        object_type: "image",
        object_size: desktopCoverFile.size,
      },
    });

    if (key) body.desktop_cover_image = key;
  }

  if (phoneCoverFile) {
    const key = await uploadFile({
      file: phoneCoverFile,
      signBody: {
        item_type: "course",
        item_id: Date.now(),
        object_name: phoneCoverFile.name,
        object_type: "image",
        object_size: phoneCoverFile.size,
      },
    });

    if (key) body.phone_cover_image = key;
  }

  if (!Object.keys(body).length) return true;

  return await api.patch<ApiResponse<Banner>>(`admin/banner/${uuid}/`, body)
  .then(() => true)
  .catch(() => false);
};